export function isHorizontal(direction) {
	return direction === 'horizontal'
}
